import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

import { TranslateModule } from "@ngx-translate/core";
import { ImageCropperModule } from 'ngx-image-cropper';

import { UploadSimpleComponent } from './simple/upload-simple.component';
import { FormModule } from "../form/form.module";
import { UploadSimpleContentComponent } from './simple/content/upload-simple-content.component';
import { PipesModule } from "../../../pipes/pipes.module";

@NgModule({
  declarations: [UploadSimpleComponent, UploadSimpleContentComponent],
  exports: [
    UploadSimpleComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PipesModule,
    FormModule,
    MatIconModule,
    MatInputModule,
    ImageCropperModule
  ]
})
export class UploadModule {
}
